<div class="flxClmn">
    <div class="page-title-container flxClmn-center">
        <div class="page-title-inner-container">
            <span class="page-title">Cases</span>
        </div>
        <div class="page-subtitle-container">
            <span class="page-subtitle">Archive cases and saved queries</span>
        </div>
    </div>
    <div class="page-inner-content-holder no-scroll flxClmn">
        <!--cases table-->
        <trustifi-table-c
            class="trustifi-table" style="flex: 1 0; z-index: 5;"
            [list]="cases"
            [headers]="[
                {text:'Date', sortKey:'created', width: '160px'},
                {text:'Name', sortKey:'name', width: '15%'},
                {text:'Query', width: '25%'},
                {text:'Shared With'},
                {text:'Sharing Expiration', sortKey:'sharing.expiration', width: '180px'},
            ]"
            [cellsPrototype]="[
                {textKey: 'created', textType: 'dateAndTime'},
                {textKey: 'name'},
                {html: 'caseQueryCell'},
                {html: 'sharedWithCell'},
                {html: 'sharingExpCell'},
            ]"
			[bulkActions] = "{
				enable: true,
				selectBulkActionCb:	selectMultipleCaseAction,
				initBulkActionsFunction: showCaseBulkActions,
				showInRed: {enable: true, terms: ['Remove']}
			}"
            [cellActions] = "{
                enable: true,
                selectItemActionCb:	selectCaseAction,
                initActionsFunction: showCaseActions
            }"
            (searchFunction)="searchCases($event.searchTerm, $event.activeFilters)"
            [options]="{
                exportToCsvFunction: exportToCsv,
                loadingTableFlag: loadingCasesInProcess,
                refreshFunction: getArchiveCases,
                itemsNameSingular: 'case',
                defaultSortKey: '-created'
            }"
        >
			<ng-template #customCells let-item let-cellId="cellId">
				<!--case query cells-->
				<div *ngIf="cellId === 'caseQueryCell'">
					<div class="flxRow hSpace2 " style="flex:1 0;">
						<div class="flxClmn ellipsis" style=" flex: 1.5 0;">
							<div *ngIf="item.query.conditionsOperator === dic.CONSTANTS.archiveCaseConditionsOperator.or.value" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b>Conditions logic:</b>
								<span style="display: block;">Match ANY (OR)</span>
							</div>
							<div *ngIf="item.query.message_id" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b>Message ID:</b>
								<span [tooltip]="item.query.message_id" style="display: block;">{{item.query.message_id}}</span>
							</div>
							<div *ngIf="item.query.from" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b *ngIf="!item.query.fromNegate">From:</b>
								<b *ngIf="item.query.fromNegate">From is <b style="color: var(--bs-danger)">NOT</b>:</b>
								<span [tooltip]="item.query.from" style="display: block;">{{item.query.from}}</span>
							</div>
							<div *ngIf="item.query.rcptTo" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b *ngIf="!item.query.rcptToNegate">Recipients:</b>
								<b *ngIf="item.query.rcptToNegate">Recipients are <b style="color: var(--bs-danger)">NOT</b>:</b>
								<span [tooltip]="item.query.rcptTo" style="display: block;">{{item.query.rcptTo}}</span>
							</div>
							<div *ngIf="item.query.subject" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b *ngIf="!item.query.subjectNegate">Subject:</b>
								<b *ngIf="item.query.subjectNegate">Subject is <b style="color: var(--bs-danger)">NOT</b>:</b>
								<span [tooltip]="item.query.subject" style="display: block;">{{item.query.subject}}</span>
							</div>
							<div *ngIf="item.query.period" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b>Period:</b>
								<span style="display: block;">{{dic.CONSTANTS.trendsPeriod[item.query.period]?.display}}</span>
								<span *ngIf="item.query.period === dic.CONSTANTS.trendsPeriod.range.value">
									({{ item.query.range.start | date:'MM/dd/yyyy' }} - {{ item.query.range.end | date:'MM/dd/yyyy' }})
								</span>
							</div>
							<div *ngIf="item.query.hasAttachments" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b>Has Attachments:</b>
								<span style="display: block;">Yes<span *ngIf="item.query.attachmentName"> ({{item.query.attachmentName}})</span></span>
							</div>
							<div *ngIf="item.query.text" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b *ngIf="!item.query.textNegate">Contains the words:</b>
								<b style="white-space: normal;" *ngIf="item.query.textNegate">Does <b style="color: var(--bs-danger)">NOT</b> contain the words:</b>
								<span [tooltip]="item.query.text" style="display: block;">{{item.query.text}}</span>
							</div>
							<div *ngIf="item.query.compliance?.length" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b>Compliance:</b>
								<span style="display: block;" [tooltip]="item.query.compliance.join(', ')">{{item.query.compliance.join(', ')}}</span>
							</div>
							<div *ngIf="item.query.mailbox" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b>Mailbox:</b>
								<span [tooltip]="item.query.mailbox" style="display: block;">{{item.query.mailbox}}</span>
							</div>
							<div *ngIf="item.query.sizeMin || item.query.sizeMax" class="ellipsis flxRow hSpace05" style="margin: 1px 0;">
								<b>Size:</b>
								<span style="display: block;">{{item.query.sizeMin ? (item.query.sizeMin / 1048576 | number:'1.0-2') + ' MB' : '0 MB'}} - {{item.query.sizeMax ? (item.query.sizeMax / 1048576 | number:'1.0-2') + ' MB' : 'No limit'}}</span>
							</div>
							<div *ngIf="item.query.scanStatus" class="flxRow hSpace05" style="margin: 1px 0; max-width: 260px;">
								<b>Scan Status:</b>
								<span class="ellipsis">{{item.query.scanStatus}}</span>
							</div>
						</div>
					</div>
				</div>
				<!--shared with cells-->
				<div *ngIf="cellId === 'sharedWithCell'">
					<span [ngStyle]="{'text-align':'center'}"
						  [tooltip]="item.sharing?.reviewers?.length ? _.map(item.sharing.reviewers, 'email').join(', ') : 'this case hasn\'t been shared'">
                    {{item.sharing?.reviewers?.length ? _.map(item.sharing.reviewers, 'email').join(', ') : 'N/A'}}
                </span>
				</div>
				<!--sharing expiration cells-->
				<div *ngIf="cellId === 'sharingExpCell'">
					<span [ngStyle]="item.sharing && item.sharing.is_sharing_expired && {'color' : 'red'}">
                    {{item.sharing && item.sharing.expiration ? (item.sharing.expiration | date:'MM/dd/yyyy') : 'N/A'}}
                </span>
				</div>
			</ng-template>
            <div tableButtons>
                <div class="flxRow hSpace1" style="align-items: flex-end;">
                    <btn-c endIcon="far fa-plus" (action)="openNewCasePopup();">
                        Create New Case
                    </btn-c>
                </div>
            </div>
        </trustifi-table-c>
    </div>

    <popup-c *ngIf="createEditCasePopup?.show"
           head="{{createEditCasePopup.isEditCase ? 'Edit Case' : 'Create a new case for archive'}}"
           size="large" width="730px"
           (closeCb)="createEditCasePopup = null;"
           (confirmCb)="applyCreateEditCasePopup()"
           [buttons]="{cancel: 'Cancel', confirm: {text: createEditCasePopup.isEditCase ? 'Confirm' : 'Create case'}}">
        <div class="flxClmn vSpace3 animated fadeIn" style="flex: 1 0; position: relative; z-index: 20; overflow: auto;">
            <div class="flxRow vSpace1">
                <span style="font-size: 1.1rem; flex-shrink: 0; font-family: 'Roboto Condensed', sans-serif;">Case Name:</span>
				<input class="one-lined-input w100" style="margin: 0; font-size: 0.9rem; max-width: 250px; height: auto; background: transparent;"
					   id="caseNameInput"
					   [ngStyle]="createEditCasePopup.isEditCase && {'border' : 'none !important', 'cursor' : 'not-allowed'}"
					   [(ngModel)]="createEditCasePopup.currentCase.name" maxlength="320"
					   [readonly]="createEditCasePopup.isEditCase"
					   type="text">
            </div>

            <div class="flxClmn vSpace1">
                <span style="font-size: 1.1rem; font-family: 'Roboto Condensed', sans-serif;">Archive Search Parameters:</span>
                <div style="flex: 1 0; padding: 0 10px 15px; background: #f9f9f9;" class="flxClmn-around">
					<div class="flxClmn vSpace2 bs-enabled" style="flex: 1 0;">
						<!-- RADIO: Normal search -->
						<div class="flxRow hSpace2" style="align-items: start; padding-top: 1rem;" (click)="createEditCasePopup.queryType = queryTypes.normal">
							<div style="width: 10px;">
								<label class="radio-container" style="transform: scale(0.85); margin-top: 8px;">
									<input type="radio" name="byIdQuery" [value]="queryTypes.normal"
										   [(ngModel)]="createEditCasePopup.queryType">
									<span class="checkmark"></span>
								</label>
							</div>

							<!-- Normal Query Block -->
							<div class="flxClmn vSpace1" style="flex: 1 0;"
								 [ngStyle]="createEditCasePopup.queryType === queryTypes.messageIdOnly ? {'opacity': '0.5', 'pointer-events': 'none'} : {}">

								<!-- Conditions logic (AND/OR) -->
								<div class="flxRow align-items-center gap-3">
									<div style="flex-basis: 130px; flex-shrink: 0;">
										<span>Conditions logic:</span>
									</div>
									<app-dropdown-c class="w100 m-0" style="max-width: 415px;"
													[text]="dic.CONSTANTS.archiveCaseConditionsOperator[createEditCasePopup.currentCase.query.conditionsOperator]?.display || dic.CONSTANTS.archiveCaseConditionsOperator.and.display">
										<ul>
											<li *ngFor="let operatorObj of dic.CONSTANTS.archiveCaseConditionsOperator | keyvalue: gs.returnZero"
												(click)="createEditCasePopup.currentCase.query.conditionsOperator = operatorObj.value.value">
												{{ operatorObj.value.display }}
											</li>
										</ul>
									</app-dropdown-c>
								</div>
								<span *ngIf="createEditCasePopup.currentCase.query.conditionsOperator === dic.CONSTANTS.archiveCaseConditionsOperator.or.value"
									  class="animated fadeIn" style="font-size: 12px; color: #486db5;">
									Emails will be included if they match at least one of: From / Recipients / Subject / Contains the words.
									The date, attachments, compliance and "Negative" conditions will still apply to all results.
								</span>

								<!-- From -->
								<div class="flxRow align-items-center gap-3">
									<div style="flex-basis: 130px; flex-shrink: 0;">
										<span *ngIf="!createEditCasePopup.currentCase.query.fromNegate">From:</span>
										<span *ngIf="createEditCasePopup.currentCase.query.fromNegate">From is <b style="color: var(--bs-danger)">NOT</b>:</span>
									</div>
									<input id="caseFromInput" style="margin: 0; background-color: #ffffff78;" class="one-lined-input w100" placeholder="Email, domain or partial address (e.g. john)" type="text"
										   [(ngModel)]="createEditCasePopup.currentCase.query.from">
									<i style="font-weight: 400;" class="far fa-question-circle"
									   tooltip="Enter a full email or domain for an exact match, or at least 3 characters of the sender's address (e.g. a username without the domain) to find every sender containing it">
									</i>
									<checkbox class="text-danger" style="font-size: 11px;" [(model)]="createEditCasePopup.currentCase.query.fromNegate">Negative</checkbox>
								</div>

								<!-- Recipients -->
								<div class="flxRow align-items-center gap-3">
									<div style="flex-basis: 130px; flex-shrink: 0;">
										<span *ngIf="!createEditCasePopup.currentCase.query.rcptToNegate">Recipients:</span>
										<span *ngIf="createEditCasePopup.currentCase.query.rcptToNegate">Recipients are <b style="color: var(--bs-danger)">NOT</b>:</span>
									</div>
									<input id="caseRecipientsInput" style="margin: 0; background-color: #ffffff78;" class="one-lined-input w100" placeholder="Email/Domain  separated by commas" type="text"
										   [(ngModel)]="createEditCasePopup.currentCase.query.rcptTo">
									<checkbox class="text-danger" style="font-size: 11px;" [(model)]="createEditCasePopup.currentCase.query.rcptToNegate">Negative</checkbox>
								</div>

								<!-- Subject -->
								<div class="flxRow align-items-center gap-3">
									<div style="flex-basis: 130px; flex-shrink: 0;">
										<span *ngIf="!createEditCasePopup.currentCase.query.subjectNegate">Subject:</span>
										<span *ngIf="createEditCasePopup.currentCase.query.subjectNegate">Subject is <b style="color: var(--bs-danger)">NOT</b>:</span>
									</div>
									<input id="caseSubjectInput" style="margin: 0; background-color: #ffffff78;" class="one-lined-input w100" placeholder="Email's subject (exact or partial)" type="text"
										   [(ngModel)]="createEditCasePopup.currentCase.query.subject">
									<checkbox class="text-danger" style="font-size: 11px;" [(model)]="createEditCasePopup.currentCase.query.subjectNegate">Negative</checkbox>
								</div>

								<!-- Text contains -->
								<div class="flxRow align-items-center gap-3">
									<div style="flex-basis: 130px; flex-shrink: 0;">
										<span *ngIf="!createEditCasePopup.currentCase.query.textNegate">Contains the words:</span>
										<span style="white-space: normal;" *ngIf="createEditCasePopup.currentCase.query.textNegate">Does <b style="color: var(--bs-danger)">NOT</b> contain the words:</span>
									</div>
									<input id="caseContainWordsInput" style="margin: 0; background-color: #ffffff78;" class="one-lined-input w100" placeholder="Email's content (exact or partial)" type="text"
										   [(ngModel)]="createEditCasePopup.currentCase.query.text">
									<checkbox class="text-danger" style="font-size: 11px;" [(model)]="createEditCasePopup.currentCase.query.textNegate">Negative</checkbox>
								</div>

								<!-- Date -->
								<div class="flxRow align-items-center gap-3">
									<span style="flex-basis: 130px;">Date:</span>
									<app-dropdown-c class="f-1-0 m-0" style="max-width: 415px;" [text]="dic.CONSTANTS.trendsPeriod[createEditCasePopup.currentCase.query.period]?.display">
										<ul style="max-height: 140px; overflow: auto;">
											<li *ngFor="let periodObj of casesPeriods | keyvalue: gs.returnZero"
												(click)="createEditCasePopup.currentCase.query.period = periodObj.value.value">
												{{ periodObj.value.display }}
											</li>
										</ul>
									</app-dropdown-c>
								</div>

								<!-- Date Range -->
								<div *ngIf="createEditCasePopup.currentCase.query.period === dic.CONSTANTS.trendsPeriod.range.value"
									 class="flxRow align-items-center gap-1" style="padding-left: 145px;">
									<span>Date Range:</span>
									<date-picker-c [(dateModel)]="createEditCasePopup.currentCase.query.range"
												   [isRange]="true" class="w-100" style="max-width: 341px;"
												   [dateFormat]="'mm/dd/yyyy'">
									</date-picker-c>
								</div>

								<!-- Attachments -->
								<div class="flxRow align-items-center gap-3">
									<checkbox [(model)]="createEditCasePopup.currentCase.query.hasAttachments">
										Has attached files
									</checkbox>
									<!--CC: optional attachment name filter, disabled when "has attached files" is not checked-->
									<input id="caseAttachmentNameInput" style="margin: 0; background-color: #ffffff78; max-width: 300px;" class="one-lined-input w100" placeholder="Attachment name (optional)" type="text"
										   [disabled]="!createEditCasePopup.currentCase.query.hasAttachments"
										   [(ngModel)]="createEditCasePopup.currentCase.query.attachmentName">
								</div>

								<!-- Advanced toggle (optional) -->
								<div class="flxRow mt-3">
									<b class="cursor-pointer" (click)="showNewCaseAdvanced = !showNewCaseAdvanced">
										Advanced
										<i class="fa" [ngClass]="showNewCaseAdvanced ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
									</b>
								</div>

								<!-- Advanced Content (optional) -->
								<div class="flxClmn gap-3" *ngIf="showNewCaseAdvanced">
									<div class="flxRow align-items-center gap-3">
										<span style="flex-basis: 130px;">Compliance:</span>
										<app-dropdown-c [items]="compliances" style="width: 67%;"
														[isMultipleSelection]="true"
														itemDisplayKey="name">
										</app-dropdown-c>
									</div>
									<span style="font-size: 12px;">Will apply only to outbound emails that were sent with Trustifi and scanned for sensitive content</span>
								</div>
							</div>
						</div>

						<!-- RADIO: Message ID -->
						<div class="flxRow hSpace2" style="margin-top: 10px;" (click)="createEditCasePopup.queryType = queryTypes.messageIdOnly">
							<div style="width: 10px;">
								<label class="radio-container" style="transform: scale(0.85); margin-top: 8px;">
									<input type="radio" name="byIdQuery" [value]="queryTypes.messageIdOnly"
										   [(ngModel)]="createEditCasePopup.queryType">
									<span class="checkmark"></span>
								</label>
							</div>

							<!-- Message ID Input -->
							<div class="flxRow" style="align-items: center; flex: 1 0;"
								 [ngStyle]="createEditCasePopup.queryType === queryTypes.normal ? {'opacity': '0.5', 'pointer-events': 'none'} : {}">
								<div style="flex-basis: 130px;">
									<span>Message ID:</span>
								</div>
								<input class="one-lined-input" style="width: 67%; background-color: #ffffff78;"
									   [ngClass]="{'border-danger' : createEditCasePopup.messageIdErr}"
									   [(ngModel)]="createEditCasePopup.currentCase.query.message_id" type="text"
									   placeholder="Exact message ID">
							</div>
						</div>

					</div>
				</div>
            </div>
        </div>
    </popup-c>

	<archive-cases-operations-component #caseOperationsEl></archive-cases-operations-component>
</div>
